
export * from './common-product/common-product.component';
export * from './multiple-insertion/multiple-insertion.component';
export * from './price-consultation/price-consultation.component';
export * from './cash-in/cash-in.component';
export * from './cash-out/cash-out.component';
export * from './change-ticket/change-ticket.component';
export * from './sales-of-the-day-and-returns/sales-of-the-day-and-returns.component';
